const LOCALE_MAP: Record<string, string> = {
  pt_BR: 'pt-BR',
  pt: 'pt-PT',
  en: 'en-US',
};

export function toIntlLocale(lang: string | undefined): string {
  if (!lang) return 'pt-PT';
  return LOCALE_MAP[lang] ?? 'pt-PT';
}
